import { ComponentStyleConfig } from "@chakra-ui/react";

const hoverStyle = {
	borderColor: "brand.highlight",
	".chevron-right": {
		bg: "brand.blue",
		transition: "background-color 0.5s ease",
	},
};
const UserActionSection: ComponentStyleConfig = {
	baseStyle: {
		wrapper: {
			py: 8,
			bg: "brand.blue",
			alignItems: "center",
			gap: 10,
			px: 3.5,
		},
		headline: {
			maxW: "container.xl",
			textAlign: "center",
		},
		cardsWrapper: {
			maxW: "container.xl",
			display: "grid",
			gridTemplateColumns: {
				base: "1fr",
				md: "repeat(2, 1fr)",
				lg: "repeat(3, 1fr)",
			},
			gap: 5,
		},
		iconLeftWrapper: {
			w: "3.125rem",
			h: "3.125rem",
			bg: "white",
			border: "1px solid",
			borderRadius: "100vw",
			borderColor: "brand.blue",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			flexShrink: 0,
		},
		card: {
			bg: "brand.lighter",
			color: "brand.blue",
			border: "2px solid",
			borderColor: "brand.light",
			borderRadius: 5,
			display: "flex",
			gap: 3,
			alignItems: "center",
			py: 8,
			px: 5,
			lineHeight: 1.25,
			justifyContent: "flex-start",
			boxShadow: "drop",
		},
		iconRight: {
			bg: "white",
			w: 8,
			h: 8,
			color: "brand.highlight",
			borderRadius: "100vw",
			ml: "auto",
			boxShadow: "drop",
		},
		textWrapper: {
			display: "flex",
			flexDir: "column",
			alignItems: "start",
		},
		label: {
			fontWeight: 600,
			fontSize: "1.25rem",
			pb: 2.5,
			textAlign: "start",
		},
		text: {
			fontWeight: 400,
			textAlign: "left",
			lineHeight: 1.25,
		},
	},
	variants: {
		link: {
			card: {
				textDecor: "none",
				_hover: hoverStyle,
			},
		},
		modal: {
			card: {
				whiteSpace: "normal",
				height: "unset",
				_active: {
					bg: "brand.lighter",
				},
				_hover: hoverStyle,
			},
		},
	},
};

export default UserActionSection;
